export enum DocumentStatus {
  NO_CORRESPONDE = 'no corresponde',
  VALIDADO = 'validado',
  OBSERVADO = 'observado',
  SUBIDO = 'si',
  NO_SUBIDO = 'no',
}
